import { Component, OnInit, OnDestroy, ViewChild } from '@angular/core';
import { Subscription } from 'rxjs/Rx';
import { TimerObservable } from 'rxjs/observable/TimerObservable';
import { ViewContainerRef } from '@angular/core';
import { Services } from '../app.service';
import { Router } from '@angular/router';
import { SecurityManager } from '../app.sec.component';
import { Title } from '@angular/platform-browser';

import { BrowserModule } from '@angular/platform-browser'
@Component({
  // changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [Services, SecurityManager],
  templateUrl: './app.signup.component.html'
})
export class SignupComponent implements OnInit, OnDestroy {
  Var = {
    mode: 'signin',
    codeHasSent: false,
    requestHasSent: false,
    codeConfirmRequestHasSent: false
  };

  @ViewChild('infoForm') public form;
  confirmationResponse = null;


  firstname = null;
  @ViewChild('firstname') set firstnameSetter(theElementRef: ViewContainerRef) {
    this.firstname = theElementRef;
  }
  lastname = null;
  @ViewChild('lastname') set lastnameSetter(theElementRef: ViewContainerRef) {
    this.lastname = theElementRef;
  }


  userInfo = {
    Mobile: null,
    FirstName: null,
    LastName: null,
  };
  response = null;
  ticks = 90;
  errorCounter = 0;
  subscription: Subscription;

  constructor(private services: Services, private router: Router, private security: SecurityManager, private titleService: Title) {

    document.body.style.backgroundImage = 'url("assets/images/Login.jpg")';

  }

  onSwitchModeClick = function (mode) {

    this.Code = null;
    this.response = null;
    this.Var.mode = mode;
    this.Var.requestHasSent = false;
    this.Var.codeHasSent = false;
    this.ticks = '';
    this.userInfo = {
      Mobile: null,
      FirstName: null,
      LastName: null,
    };

    if (this.subscription) {
      this.subscription.unsubscribe();

    }
    this.errorCounter = 0;

  }

  handleCodeError = function () {
    this.Code = null;

    this.ticks = '';


    if (this.subscription) {
      this.subscription.unsubscribe();

    }


  }
  onGetCodeClick = function () {
    this.Code = null;
    this.errorCounter = 0;
    this.response = null;

    this.Var.requestHasSent = true;
    if (!this.userInfo.FirstName) {

      this.userInfo.FirstName = null;
      this.userInfo.LastName = null
    }
    this.services.siginUser(this.userInfo).subscribe(
      (data) => {

        this.response = data;
        if (data.RStatus !== 'Fail') {
          this.Var.codeHasSent = true;
          this.startTimer();
        } else {
          this.ticks = '';
        }

      },
      (err) => {
        this.Var.codeHasSent = false;
        this.Var.requestHasSent = false;

        if (this.subscription) {
          this.subscription.unsubscribe();

        }

        this.error = err;
        this.ticks = 90;
      });
  }
  onConfirmCodeClick = function () {

    this.Var.codeConfirmRequestHasSent = true;
    this.services.confirmation({ Mobile: this.userInfo.Mobile, Code: this.Code }).subscribe(
      (data) => {
        // this.subscription.unsubscribe();
        this.confirmationResponse = data;
        if (data.UserID) {
          this.security.saveToken({ UserID: data.UserID, Token: data.Token });
          this.router.navigateByUrl('home/cards');
        } else {
          this.Var.codeConfirmRequestHasSent = false;
          this.errorCounter++;
          this.response = data;
          if (this.errorCounter === 3) {
            this.onSwitchModeClick(this.Var.mode);
          } else {
            this.handleCodeError();
          }

        }
      },
      (err) => { this.error = err });
  }



  onAboutClick() {
    this.router.navigateByUrl('about');
  }


  keyEventHandler(eventKey) {
    if (eventKey === 13 && this.form.valid) {
      if (!this.Var.codeHasSent) {
        this.onGetCodeClick();
      } else {
        this.onConfirmCodeClick();
      }
    }
  }
  public setTitle(newTitle: string) {
    this.titleService.setTitle(newTitle);
  }
  ngOnInit() {
    this.setTitle('پلنتو | برنامه ریزی مدرن بر فراز ابرها')
  }


  startTimer = function () {
    this.ticks = 90;
    const timer = TimerObservable.create(0, 1000);
    this.subscription = timer.subscribe(t => {
      if (this.ticks > 1) {
        this.ticks = this.ticks - 1;

      }
      // tslint:disable-next-line:one-line
      else {
        if (this.subscription) {
          this.subscription.unsubscribe();

        } this.Var.codeHasSent = false;
        this.ticks = 90;
        this.Var.requestHasSent = false;
        this.response = null;
      }
    });
  }

  ngOnDestroy() {

    if (this.subscription) {
      this.subscription.unsubscribe();

    }
  }



}





// WEBPACK FOOTER //
// C:/Websites/Planeto/PlanetoAngular/src/app/signin/app.signup.component.ts